export default __webpack_public_path__ + "static/media/sheets.c72f3403.png";